import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54f0e6b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M10.4166 20.8333V14.5833H14.5833V20.8333H19.7916V12.5H22.9166L12.5 3.125L2.08331 12.5H5.20831V20.8333H10.4166Z",
    fill: "#888AA5"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "title__text" }, "환자 리스트", -1))
const _hoisted_4 = { class: "table__box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table__header" }, [
  /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"35%"} }, "중환자실"),
  /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"35%"} }, "환자번호"),
  /*#__PURE__*/_createElementVNode("div", { style: {"flex-basis":"30%"} }, "이름")
], -1))
const _hoisted_6 = { class: "table__body my-scroll" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { style: {"flex-basis":"35%"} }
const _hoisted_9 = { style: {"flex-basis":"35%"} }
const _hoisted_10 = { style: {"flex-basis":"30%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["component filtered", {'scroll':_ctx.patients.length>23}])
  }, [
    _createElementVNode("div", {
      class: "home-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.movePage('Monitoring')))
    }, _hoisted_2),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patients, (patient, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: patient.PT_NO,
            class: _normalizeClass(["table__tr", {'selected': idx == _ctx.selectedPatientIdx}]),
            onClick: ($event: any) => (_ctx.setPatientData(patient))
          }, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(patient.WD_DEPT_CD), 1),
            _createElementVNode("div", _hoisted_9, _toDisplayString(patient.PT_NO), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString(patient.PT_NM), 1)
          ], 10, _hoisted_7))
        }), 128))
      ])
    ])
  ], 2))
}